import { render } from "./ApiGuideCampaignPage.vue?vue&type=template&id=0b42eae7"
import script from "./ApiGuideCampaignPage.vue?vue&type=script&lang=js"
export * from "./ApiGuideCampaignPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__